import {
    Flex,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';
import { CONFIGURE_2FA_KC_ACTION, keycloak } from '../../auth/keycloak';

interface permissionProps {
    isOpen: boolean;
    onClose: () => void;
}

export const TwoFactorPermission: React.FC<permissionProps> = ({ isOpen, onClose }) => {
    return (
        <Modal closeOnOverlayClick={true} isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent className={'setup-2fa-content'}>
                <ModalHeader className={'setup-2fa-header'}>
                    <Flex>
                        <Text>Two-Factor authentication required</Text>
                    </Flex>
                </ModalHeader>
                <ModalBody className={'setup-2fa-body'}>
                    <Text>
                        For security reasons, you will need to set up Two-Factor authentication
                        (2FA) on your STREAMSIX account in order to use payment features.
                    </Text>
                    <Flex
                        className={'twofactor-button'}
                        onClick={() => {
                            keycloak.login({ action: CONFIGURE_2FA_KC_ACTION });
                        }}
                    >
                        Setup 2FA
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
